import { createBrowserRouter } from "react-router-dom";
import { Home } from "../components/Home";
import { Draft } from "../components/Researcher/Draft";
import App from "../App";
import { ProjectInfo } from "../components/Researcher/ProjectInfo";
import { EthicalReq } from "../components/Researcher/EthicalRequest";
import { Registered } from "../components/RegistrationSuccess";
import { ProfileEdit } from "../components/Researcher/EditProfile";
import { VolunteerInform } from "../components/Researcher/VolunteerInform";
import { StaffProjectInfo } from "../components/Staff/StaffProjectInfo";
import { PresProjectInfo } from "../components/President/PresProjectInfo";
import { ResetPassword } from "../components/ResetPassword";
import { CommitteeListManage } from "../components/President/CommitteeManage";
import { RequestListView } from "../components/President/RequestList";
import { CommitteeData } from "../components/Committee/CommitteeInfo";
import { UploadOtherDocument } from "../components/Researcher/UploadDocument";

export const router = createBrowserRouter([
    {
      path: "/VU_HREC",
      element: <App />,
      children: [
        { path: "/VU_HREC", element: <Home /> }, 
        { path: "/VU_HREC/", element: <Home /> }, 
        { path: "/VU_HREC/Draft", element: <Draft /> }, 
        { path: "/VU_HREC/ProjectInfo", element: <ProjectInfo /> },
        { path: "/VU_HREC/ProjectInfo/:projectID", element: <ProjectInfo /> },
        { path: "/VU_HREC/EhticalReq", element: <EthicalReq /> }, 
        { path: "/VU_HREC/VolunteerForm", element: <VolunteerInform /> }, 
        { path: "/VU_HREC/UploadDoc", element: <UploadOtherDocument /> },

        { path: "/VU_HREC/RegisterConfirm/:id", element: <Registered /> }, 
        { path: "/VU_HREC/Profile", element: <ProfileEdit /> }, 
        { path: "/VU_HREC/ResetPassword/:id", element: <ResetPassword /> },

        //staff
        { path: "/VU_HREC/StaffProjectInfo", element: <StaffProjectInfo /> }, 

        //president
        { path: "/VU_HREC/CommitteeManagement", element: <CommitteeListManage /> },
        { path: "/VU_HREC/PresProjectInfo", element: <PresProjectInfo /> },
        { path: "/VU_HREC/RequestListView", element: <RequestListView /> },

        //committee
        { path: "/VU_HREC/RequestReview", element: <CommitteeData /> },
        
      ],
    },
  ]);